import type React from "react";
import { Box, Typography } from "@mui/material";

const EmptyState: React.FC = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 8,
        color: "text.secondary",
        backgroundColor: "grey.50",
        borderRadius: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Select Events to Begin
      </Typography>
      <Typography variant="body2">
        Choose one or more events from the dropdown above to start assigning
        crew members to roles.
      </Typography>
    </Box>
  );
};

export default EmptyState;
